import ImageCollectionPage from "../components/ImageCollectionPage";

export default function BeautyHair() {
  return <ImageCollectionPage title="Beauty - Hair" path="/culture/beauty-hair" collection="culture_beauty_hair" />;
}
